import React from 'react';
import { Panel, PanelHeader, PanelBody } from './../../components/panel/panel.jsx';
import SU3Password02 from './../workinstructions/images/SU3password02.png';
import SU3Password01 from './../workinstructions/images/SU3password01.png';

class SU3Password extends React.Component {
	async componentDidMount() {
    document.title = "Nokia MN";    
  }
	render() {
		return (
			<div>
		{/*				<ol className="breadcrumb float-xl-end">
					<li className="breadcrumb-item active">Cookie Acceptance Banner</li>
				</ol>
				<h1 className="page-header">Cookie Acceptance Banner <small>header small text goes here...</small></h1>   */}
				<Panel>
					<PanelHeader>Change Password</PanelHeader>
					<PanelBody>
					<h2>Change Password</h2>
						<h2></h2>
						<p>Changing Psssword can be done with SU3 transaction<br/>
						Use SU3 =&gt; click on icon "password"<br/ >				

							<p> <img src={SU3Password01} alt="Click on icon password" style={{ maxWidth: '100%', height: 'auto' }} /> </p>
							Fill your currenct/old password in fill your new password 2 times in =&gt; save
							<p> <img src={SU3Password02} alt="Fill in new password" style={{ maxWidth: '100%', height: 'auto' }} /> </p>

						</p>
					</PanelBody>
						<footer style={{ marginTop: '2rem', padding: '1rem 0', borderTop: '1px solid #ddd' }}>
						  <p style={{ textAlign: 'center', fontSize: '0.9rem', color: '#666' }}>
						    &copy; Nov 2025 by TQT Tong. All rights reserved.
						  </p>
						</footer>
								
				</Panel>
		
			</div>
		)
	}
}

export default SU3Password;
